import React, { useEffect, useState } from 'react'
import defaultUser from '../../../assets/images/defaultUser.png'
import { getStorage, getDownloadURL, ref } from "firebase/storage";
import { app } from '../../../firebase/firebaseConfig';
import { useNavigate } from 'react-router-dom';
import * as routes from '../../../routes/route'
import deleteBtn from '../../../assets/images/delete.svg'
import DeleteModal from '../../../components/DeleteModal/DeleteModal';
import { useDispatch, useSelector } from 'react-redux';
import { removeUserFromGroupActivity } from '../../../redux/actions/GroupClassesAndActivityActions/GroupClassesAndActivityAction';
import { maskContact } from '../../../utils/helpers/masking';

function Guest({item, guestType, activityId, title}) {

    const [imageUrl, setImageUrl] = useState(null);
    const [deleteModal, setDeleteModal] = useState(null);
    const {updateLoading} = useSelector(state=> state.groupClassesAndActivityReducer)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const onDelete= (id)=>{
        dispatch(removeUserFromGroupActivity({
            userId: item.user_id,
            activityId: item.activity_id,
            onSuccessCallback: ()=>{
                setDeleteModal(false)
            }
        }))
    }


    useEffect(()=>{
        
        if(item.profile_pic.length){
            try{
                const storage = getStorage(app);
                const imageRef = ref(storage, item.profile_pic);
    
                getDownloadURL(imageRef).then((url) => {
                    setImageUrl(url);
                }).catch((error) => {
                console.error("Error getting download URL: ", error);
                });
            }catch(e){
                
            }
        }
  }, [item]);
  
  
  return (
    <div className='searched-guest-container'>
        <div className='guest-data d-flex justify-content-between align-items-start'>
            <div className="d-flex">
                <div className='profile-img'>
                    <img src={!item.profile_pic ? defaultUser : imageUrl } alt=""  width={"100%"}/>
                </div> 
                <div className='profile-content'>
                    <div className="guest-name">{`${item.first_name || ''} ${item.last_name || ''}`.trim()}</div>
                    <div className='d-flex'>
                        <div className="guest-check">Phone Number: &nbsp;</div>
                        <div className="date-time">{maskContact(item?.phone_number)}</div>
                    </div>
                    <div className='text-primary mt-4' style={{fontWeight: 500}} onClick={()=>{navigate(routes.VIEW_PROFILE_ENDPOINT, {state:{user_id: item?.user_id}})}}>View Profile</div>
                </div>
            </div>
            <div className='d-flex align-items-center remove-btn' onClick={()=>setDeleteModal(true)}>
                <img src={deleteBtn} alt="del-btn" className="me-2" />
                Remove
            </div>
        </div>
        <DeleteModal
            deleteModal={deleteModal} 
            setDeleteModal={setDeleteModal}
            message={
                <>
                  Are you sure, you want to remove {`${item.first_name || ''} ${item.last_name || ''}`.trim()} from group activity- {title}?
                </>
              }
            loading={updateLoading}
            confirmText={'Remove'}
            onDelete={()=>onDelete(item.user_id)}
        />
    </div>
  )
}

export default Guest